import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar, Footer } from "./components/Layout";
import { Hero, QuickFacts, Welcome } from "./components/SectionsTop";
import { Amenities, Prices, Gallery } from "./components/SectionsMid";
import { Guending, Faq, Contact } from "./components/SectionsBottom";
import { Impressum, Datenschutz, Agb } from "./components/Legal";
import { Toaster } from "./components/ui/toaster";
import { FloatingWhatsApp } from "./components/WhatsApp";
import useReveal from "./hooks/useReveal";
import { LanguageProvider } from "./i18n";

function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 80);
    }
  }, [location.hash]);

  return (
    <main>
      <Hero />
      <QuickFacts />
      <Welcome />
      <Amenities />
      <Prices />
      <Gallery />
      <Guending />
      <Faq />
      <Contact />
    </main>
  );
}

function Shell() {
  useReveal();
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/hausordnung" element={<Agb />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
      <FloatingWhatsApp />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
